import React from 'react';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import {RichText} from '@synergycms_core/components/generic';
import Form from '@synergycms_core/components/generic/Form';
import {withThemeJSS} from '@synergycms_core/components/providers/themeProvider';
import {compose} from "ramda";
import TextAreaField from '@synergycms_core/components/generic/Form/TextAreaField.jsx';


const GiftVoucherForm = props => {
    const {
        blocks,
        onChange,
        onBlur,
        currency
    } = props;
    const {classes} = props.theme.styles;

    return (
        <div className={classes.roomPreferences}>
            <div>
                <RichText innerStyle={[classes.labelSupText]} ucFirst={true} translate={true}>
                    _%mensaje%_
                </RichText>
            </div>
            {/* <div>
            <RichText innerStyle={[classes.title]} ucFirst={true} translate={true}>
                _%este es el mensaje que aparecerá en el cheque regalo.
                Si quieres puedes editarlo para modificarlo y personalizar tu mensaje. %_
            </RichText>

        </div>
        <br /> */}
            <Form withoutForm={true} onChange={onChange} onBlur={onBlur} innerStyle={classes.giftVoucherForm}>
                {blocks && blocks.map(block => {
                    return (
                        <div key={block.get('idx')} className={classes.giftVoucherContent}>
                            <div className={classes.roomHeader}>
                                <div className={classes.roomSubTitle}>
                                    <RichText
                                        innerStyle={classes.bonoText}>{block.get("name") + " (" + block.get("price") + currency + ")"}</RichText>
                                    <label className={[classes.inputBox].join(' ')}>
                                        <TextAreaField
                                            model={block.get("idx")}
                                            innerStyle={[classes.textAreaBox]}
                                            defaultValue={block.get('notes', '')}
                                            maxLength={400}
                                        />
                                    </label>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </Form>
        </div>
    );
};

export default compose(withThemeJSS({styleFile, link: true, displayName: 'GiftVoucherForm'}))(GiftVoucherForm);
